import { typeof as _typeof, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { utils } from '@costar/theme-ui';
import sortOrder from './sort-order.esm.js';

function isSelectOptionItem(subject) {
  return subject && _typeof(subject) === 'object' && 'label' in subject;
}
function isSelectOptionsSection(subject) {
  return isSelectOptionItem(subject) && 'options' in subject;
}
function getGroupOptions(option) {
  return isSelectOptionsSection(option) ? option.options || {} : {};
}
function optionsToArray(options, groupKey) {
  if (Array.isArray(options)) {
    return options.map(function (i) {
      return "".concat(i);
    });
  }
  if (options && utils.isNotEmptyObject(options)) {
    return utils.objectKeys(options).sort(sortOrder(options)).reduce(function (acc, cur) {
      var next = options[cur];
      var groupOptions = getGroupOptions(next);
      if (utils.isNotEmptyObject(groupOptions)) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(optionsToArray(groupOptions, "".concat(cur))));
      }
      return [].concat(_toConsumableArray(acc), ["".concat(groupKey ? groupKey + '.' : '').concat(cur)]);
    }, []);
  }
  return [];
}
function getOptionKey(item, groupKey) {
  return "".concat(groupKey ? groupKey + '.' : '').concat(item);
}

export { getGroupOptions, getOptionKey, isSelectOptionItem, isSelectOptionsSection, optionsToArray };
//# sourceMappingURL=utils.esm.js.map
